import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularLoader from '../../../../components/circularLoader/CircularLoader';
import {SearchState} from '../../../../constants/enums';
import {instruments} from '../../../../constants/constants';
import {translate} from '../../../../utils/localizationUtility';
import LibraryTrack from './LibraryTrack';

@inject('searchStore', 'trackStore')
@observer
class BankContainer extends Component {
    instruments = [
        {
            label: ` ${translate('studio.library.allInstruments')}`,
            value: ''
        },
        ...instruments.map(item => (
            {
                label: translate(`upload.form.instruments.${item.name}`),
                value: item.name
            }
        ))
    ];

    componentDidMount() {
        this.props.searchStore.fetchItems(SearchState.sampleBank);
    }

    handleLoadMore = () => {
        this.props.searchStore.fetchItems(SearchState.sampleBank);
    };

    handleFilterChange = ({target}) => {
        const {searchStore} = this.props;
        searchStore.updateSearchStr(target.value, SearchState.sampleBank);
        searchStore.fetchItems(SearchState.sampleBank, true);
    };

    render() {
        const {trackStore, searchStore, isTrackAdded, playTrack, addTrack, removeTrack} = this.props;
        const hasMoreItems = trackStore.isFetching || (trackStore.pageCount === 0 && trackStore.tracks.length) || trackStore.pageCount > trackStore.currentPage;

        return (
            <div className="m-studio-bank">
                <div className="m-studio-filter">
                    <div className="select-label">
                        {searchStore.searchStr === ''
                            ? <FormattedMessage id="studio.library.filterByInstrument"/>
                            : <Fragment>{searchStore.searchStr}</Fragment>
                        }
                    </div>
                    <select className="select-list" value={searchStore.searchStr} onChange={this.handleFilterChange}>
                        {this.instruments.map((option, index) => (
                            <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                <InfiniteScroll
                    scrollableTarget="library-modal"
                    scrollThreshold="70px"
                    className="infinite-content"
                    dataLength={trackStore.tracks.length}
                    next={this.handleLoadMore}
                    hasMore={hasMoreItems}
                    loader={<CircularLoader />}
                >
                    {
                        trackStore.tracks.map(track => (
                            <LibraryTrack
                                key={track.id}
                                track={track}
                                isTrackAdded={isTrackAdded(track.id)}
                                playTrack={playTrack(track)}
                                addTrack={addTrack(track)}
                                removeTrack={removeTrack(track)}
                            />
                        ))
                    }
                </InfiniteScroll>
            </div>
        );
    }
}

export default BankContainer;
